import i18n from '@/lang/i18n'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { ConfigurationIncidentsTypesLaboratoriesResponse } from '@/modules/configurationModule/detail/incidents/incidents-types/services/incidents-types-laboratories.dto'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { incidentsTypesLaboratoriesConfigurationServices } from '@/modules/configurationModule/detail/incidents/incidents-types/services/incidents-types-laboratories.service'
import { store } from '@/store/store'

export const columnsDefIncidentsTypesLaboratoriesGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.incidentTypes'),
            colId: 'incidentType.nameTranslationKey',
            field: 'incidentType.name',
            minWidth: 150,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.incidentSeverities'),
            colId: 'incidentSeverity.nameTranslationKey',
            field: 'incidentSeverity.name',
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.reportTitle'),
            colId: 'reportTitleTranslationKey',
            field: 'reportTitle',
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: 'flagsRenderer',
            headerName: i18n.tc('configuration.grid.reportTitleTranslations'),
            field: 'reportTitleTranslations',
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.reportModel'),
            field: 'reportFileName',
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            sortable: false
        },
        {
            type: 'checkIconRenderer',
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export interface IncidentsTypesLaboratoriesGridState extends CrudModelPaginatorLaboratory<ConfigurationIncidentsTypesLaboratoriesResponse> {
    labId: number
}
export const initialIncidentsTypesLaboratoriesGridState =
    (): IncidentsTypesLaboratoriesGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.incidents.incidentsTypes',
        columnsDef: columnsDefIncidentsTypesLaboratoriesGrid(),
        datasource: new PaginatorLaboratoryDatasource(incidentsTypesLaboratoriesConfigurationServices, store.getters.labId),
        labId: store.getters.labId
    })
